import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Modal, ProgressBar } from "@themesberg/react-bootstrap";
import { useCookies } from "react-cookie";
import {
  getListClassicSalesTicket,
  getSummaryClassicSalesTicket,
} from "../../../../controller/api/__classic__/ticketStorage";
import { exportSalesTicketStorageToExcel } from "../../../../helpers/excelExport";
import { FULL_LIST_ITEM_PER_PAGE } from "../../../../helper/helper";
import { getSaleStatus, getReturnStatus } from "../helpers/sale-status";

const toExportRow = (ticket) => ({
  ...ticket,
  saleStatusText: getSaleStatus({
    status: ticket.status,
    amount: ticket.amount,
    isExpired: ticket.isExpired,
  }).text,
  returnStatusText: getReturnStatus({
    returnedAmount: ticket.returnedAmount,
    inputAmount: ticket.inputAmount,
  }).text,
});

const ExportProcessingPopup = ({ show, onHide, filterData }) => {
  const [cookies] = useCookies(["lottmekong"]);
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const isRunning = useRef(false);

  const handleHide = useCallback(() => {
    if (isRunning.current) {
      alert("Đang xuất file, vui lòng đợi...");
      return;
    }
    setLoaded(0);
    setTotal(0);
    onHide();
  }, [onHide]);

  const runExport = useCallback(async () => {
    isRunning.current = true;
    setIsExporting(true);

    try {
      const summaryResponse = await getSummaryClassicSalesTicket(
        cookies.lottmekong,
        {
          region: filterData.region,
          channel: filterData.channel,
          numbers: filterData.numbers,
          fromDate: filterData.fromDate,
          toDate: filterData.toDate,
        },
      );

      const rows = [];
      let page = 0;
      let totalTicket = 0;

      do {
        const response = await getListClassicSalesTicket(
          cookies.lottmekong,
          {
            channel: filterData.channel,
            region: filterData.region,
            numbers: filterData.numbers,
            ticketCode: filterData.ticketCode,
            ticketType: filterData.ticketType || "all",
            fromDate: filterData.fromDate,
            toDate: filterData.toDate,
          },
          page,
          FULL_LIST_ITEM_PER_PAGE,
        );

        if (!response || !response.data || response.data.length === 0) break;

        totalTicket = response.total || 0;
        setTotal(totalTicket);
        rows.push(...response.data.map(toExportRow));
        setLoaded(rows.length);
        page += 1;
      } while (rows.length < totalTicket);

      if (rows.length === 0) {
        alert("Không có dữ liệu để xuất file Excel.");
        return;
      }

      exportSalesTicketStorageToExcel(rows, summaryResponse?.data, filterData);
    } catch (error) {
      console.error("exportSalesTicketStorage error:", error);
      alert("Xuất file Excel thất bại, vui lòng thử lại.");
    } finally {
      isRunning.current = false;
      setIsExporting(false);
      setLoaded(0);
      setTotal(0);
      onHide();
    }
  }, [cookies.lottmekong, filterData, onHide]);

  useEffect(() => {
    if (show && !isRunning.current) {
      runExport();
    }
  }, [show, runExport]);

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Đang xuất file Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {total === 0 ? (
          "Đang tính số trang..."
        ) : (
          <>
            <ProgressBar
              className="progress-md"
              variant="success"
              now={loaded}
              min={0}
              max={total}
            />
            <div className="mt-2">
              {loaded} / <b>{total}</b> vé
              {loaded >= total && " - Đang tạo file Excel..."}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleHide} disabled={isExporting}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(ExportProcessingPopup);
